import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useEffect, useState} from "react";
import { useParams } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import './setting.css'
import Menu from './menu';
import { FiCheck} from "react-icons/fi";
import {url} from '../URL.js'
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { BiQuestionMark } from "react-icons/bi";
import Swal from 'sweetalert2'



export function Setting(){
    const { isAuthenticated, user} = useAuth0();
    const usuario1 = useSelector((state)=> state.usuario)
    const [usuarioList, setUsuarioList] = useState(null)
    const [modificacionesList, setModificacionesList] = useState([])
    const [users, setUsers] = useState(null)
    const [estado, setEstado] = useState(false)
    const [nombreNew, setNombreNew] = useState('')
    const [pin, setPin] = useState(0)
    const ids = useParams()
   // console.log(users)
    useEffect(() => {
       axios.get(`${url}usuario`)
       .then(res => {
        setUsuarioList(res.data)
       })
       axios.get(`${url}usuario?id=`+ user.sub)
       .then(user => {
        setUsers(user.data)
       })
        }, [])

    function modificarNivel(e, elemento){
        let newLevel = e.target.value
        let idUser = elemento.id
        let obj = {
            id: idUser,
            nivel: newLevel
        }
        axios.put(`${url}modificarUsuario`, obj)
        alert('se modifico correctamente')
        axios.get(`${url}usuario`)
        .then(res => {
         setUsuarioList(res.data)
        })

    }
    function cambiarNombre(e){
        if(e.target.value){
            setNombreNew({nombre:e.target.value, id: user.sub})
        }
        else{
            setNombreNew('')
        }
    }
    function submitNombre(e){
        e.preventDefault()
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
        axios.put(`${url}modificarUsuario`, nombreNew).then(Toast.fire({
            icon: 'success',
            title: 'Cambio de Nombre exitoso'
          }))
        document.getElementById('nombre').value = nombreNew.nombre
        setNombreNew('')
    }
    let usuariosListFinaly = usuarioList
   // console.log(usuariosListFinaly)
    let styleImg = {
        width: '46px',
        borderRadius: '50px'
    }
    function SortArray(x, y){
        if (x.nivel < y.nivel) {return -1;}
        if (x.nivel > y.nivel) {return 1;}
        return 0;
    }
    const popover = (
        <Popover id="popover-basic">
          <Popover.Header as="h3">Diferentes Niveles</Popover.Header>
          <Popover.Body>
         
                   <strong>Nivel-1 : </strong>control total <br/>
                   <strong>Nivel-2 : </strong>crear, modificar <br/>
                   <strong>Nivel-3 : </strong>solo lectura <br/>
                   <strong>Nivel-4 : </strong>lectura estricta <br/>
          </Popover.Body>
        </Popover>
      );
    
    let usuariosListFinalySort = usuariosListFinaly?.sort(SortArray)
    //console.log(usuariosListFinalySort)
    console.log(usuariosListFinalySort)
    function activePIN(){
        setPin(1)
    }
    function cambiarPIN(e){
        e.preventDefault()
       var pinActual = users?.contrasena;
       var pinViejo = document.getElementById('pinViejo').value
       var pinNuevo = document.getElementById('pinNuevo').value
       const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })
        if(pinActual == pinViejo && pinNuevo.length == 4){
            if(window.confirm('Seguro de cambiar PIN?')){
                var cambio = {id: user.sub, contrasena: pinNuevo }
                axios.put(`${url}modificarUsuario`, cambio).then(
                      Toast.fire({
                        icon: 'success',
                        title: 'Cambio de PIN exitoso'
                      })
                )
                setPin(0)
            }

        } else if (pinActual != pinViejo) {
            alert('Pin incorrecto')
            document.getElementById('pinViejo').value = '';
            document.getElementById('pinNuevo').value = '';
        } else {
            alert('vuelva a intentarlo')
        }
    }
    return(
        <div class='container34'>
             <Menu activo={5}/>
          
            <div className="contenido342">
            <div className="cabecera">
                <div className="apre">
                    AJUSTES DE USUARIO
               </div>
           </div>
            <div className='cambia-nom'>
                <h5 className='hhh'>Cambiar nombre:</h5>
                 <input type='text' name='nombre' id='nombre'className='inputing' placeholder={users?.nombre} onChange={(e)=> cambiarNombre(e)}></input>
                 {
                    nombreNew.nombre ? <button class='pin-nuevo-s' onClick={(e)=> submitNombre(e)}><FiCheck/></button> :null
                 }
                 
            </div>
                
                 {
                    pin === 1  ?
                    <div class='nuevoPin'> 
                    <form type='submit' onSubmit={(e)=> cambiarPIN(e)}>
                       <div className="conte-div">
                    <label>Pin actual:</label>
                    <input type='password' id='pinViejo' className="sdsd55"   maxlength='4' pattern="[0-9]*" required inputmode="numeric"/>
                    </div>
                    <div className="conte-div">
                    <label>Pin nuevo:</label>
                    <input type='password'  id='pinNuevo' className="sdsd55"  autoComplete='off' maxlength='4' required pattern="[0-9]*" inputmode="numeric" />
                    </div>
                    <button class='' type='submit'><FiCheck/></button>
                    
                       
                        </form>
                        </div> : <div class='nuevo-pin'><button class='limpiar'onClick={(e)=> activePIN(e)}>CAMBIAR PIN</button> </div>
                 }
        {
            users?.nivel === 1? 
            
            <div className='todi'>
            <div className="control-u">
                <div className='ttti'>
              <p className="ni">Niveles de usuario:</p> 
                <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                        <Button size='sm' variant='outline-dark' className='butoto'><BiQuestionMark size="20px" /></Button>
                    </OverlayTrigger>
                </div>
                     
           
            </div>
            
           
            
                <div id="main-container21">
                    <div className='tablita'>
                <table class="rwd_auto fontsize">
		<thead className='head-set'>
		<tr>
			<th>Nombre</th>
            <th></th>
			<th>Correo</th>
			<th>nivel</th>
			<th>cambiar nivel</th>
		</tr>
		</thead>
		<tbody>
      
        { 
               usuariosListFinalySort?.map((elemento) => {
                    return (
                        <tr key={elemento.id} className='pase'>
                        <td><img src={elemento.imagen} style={styleImg}></img></td>
                        <td>{elemento.nombre}</td>
                        <td>{elemento.correo}</td>
                        <td>{elemento.nivel}</td>
                        <td> 

                            <select onChange={(e)=> modificarNivel(e, elemento)}>
                                <option>cambiar nivel</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                            </select>
                            
                            </td>
                        
                      </tr>
                    );
                  })
               }
              
		</tbody>
	</table>
    </div>
          
        </div>
            </div> 
            
            : <></>
           
        }
            </div>
           
        </div>
    )
}